import styled, { css, keyframes } from 'styled-components'

type StyleButtonProps = {
  size?: 'display' | 'mid' | 'small' | 'custom',
  customStyles?:any,
  isDelete?:boolean,
  loadingComplete?:boolean,
  loading?:boolean,
}
function styleMyEl(size:any, customStyles?:any) {
  switch (size) {
    case 'display':
      return css`
        min-width: 80px;
        height: 40px;
        ${customStyles}
      `;
    case 'mid':
      return css`
        min-width: 80px;
        height: 36px;
        ${customStyles}
      `;
    case 'small':
      return css`
        min-width: 68px;
        height: 30px;
        padding: 5px 10px;
        ${customStyles}
      `;
    case 'custom':
      return css`
        ${customStyles}
      `;
    default:
      return css`
        /* width: 68px; */
        height: 30px;
        ${customStyles}
      `;
  }
}

const ripple = keyframes`
  0% {
    opacity: 0.5;
    transform: scale(0);
  }
  70% {
    opacity: 0.25;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(1);
  }
`

const rippleCenter = keyframes`
  0% {
    opacity: 0.5;
    transform: scale(0.7);
  }
  70% {
    opacity: 0.25;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(1.05);
  }
`

const PrimaryButton = styled.button.withConfig({
  shouldForwardProp: (prop) => !['size', 'customStyles', 'isDelete', 'loadingComplete', 'loading'].includes(prop),
})<StyleButtonProps>`
  --ripple-x: 50%;
  --ripple-y: 50%;
  --ripple-size: 0px;
  box-sizing: border-box;
  background: ${({theme, isDelete, loadingComplete}) => loadingComplete ? theme.success : isDelete ? theme.errors[600] : theme.accent[100]};
  border-radius: ${({theme}) => theme.radius.control};
  border:none;
  /* letter-spacing: 0.45px; */
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 10px 16px;
  font-family:Inter;
  color: #FFFF;
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  white-space: nowrap;
  position: relative;
  overflow: hidden;
  transition:
    background-color 0.15s ease-out,
    transform 0.14s ease-out,
    filter 0.15s ease-out;
  ${({size, customStyles}) => styleMyEl(size, customStyles)};
  &::after {
    content: '';
    position: absolute;
    width: var(--ripple-size);
    height: var(--ripple-size);
    left: calc(var(--ripple-x) - (var(--ripple-size) / 2));
    top: calc(var(--ripple-y) - (var(--ripple-size) / 2));
    border-radius: 9999px;
    background: rgba(255, 255, 255, 0.5);
    opacity: 0;
    transform: scale(0);
    pointer-events: none;
  }
  &.btn--ripple::after {
    animation: ${ripple} 1000ms cubic-bezier(0.22, 1, 0.36, 1) forwards;
  }
  &:active:not(:disabled):not(.btn--ripple)::after {
    width: 220%;
    height: 220%;
    left: -60%;
    top: -60%;
    animation: ${rippleCenter} 1000ms cubic-bezier(0.22, 1, 0.36, 1) forwards;
  }
  &:hover:not(:disabled){
    background: ${({theme, isDelete}) => isDelete ? '#F96E67' : theme.accent[200]};
    cursor: pointer;
  }
  &:active:not(:disabled){
    background: ${({theme, isDelete}) => isDelete ? '#CD3A32' : theme.accent[300]};
    transform: scale(0.98);
    filter: saturate(0.98);

  }
  &:focus-visible{
    outline: none;
    box-shadow: ${({theme}) => theme.isDark ? theme.shadows.focusDark : theme.shadows.focus};
  }
  &:disabled{
    background: ${({theme, loadingComplete, loading}) => loadingComplete || loading ? '' : theme.isDark ? theme.palette[200] : theme.grey[400]};
    cursor: not-allowed;
  }

  @media (max-width: 768px) {
    min-width: 0;
    max-width: 100%;
    min-height: 30px;
    height: auto;
    padding-left: 8px;
    padding-right: 8px;
    flex-shrink: 1;
    white-space: normal;
    overflow-wrap: anywhere;
  }
`

export default PrimaryButton
